import { render, staticRenderFns } from "./dresser.vue?vue&type=template&id=05d917f4&"
import script from "./dresser.vue?vue&type=script&lang=js&"
export * from "./dresser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports